import React from 'react'
import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/usePaymentMethod'

const PaymentMethodListItem = (props) => {
  const {
    paymentMethod,
    paymentMethod: {
      short_name,
      title,
    },
  } = props

  const { editPaymentMethodUrl } = generateUrls(paymentMethod)

  return (
    <DashboardModuleListItem
      href={editPaymentMethodUrl}
      title={title}
    >
      <DashboardModuleListItem.TertiaryText>
        {short_name}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

PaymentMethodListItem.propTypes = {
  paymentMethod: PropTypes.object.isRequired,
}

export default PaymentMethodListItem
